<template>
    <div>
        <div class="layout">
            <div class="layout__header">
                <div class="layout__title">
                    <h3>Ítem</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                        <div class="form-group">
                            <input-field :tooltip="modelValue.descripcion!==''?modelValue.descripcion:'Seleccione...'" v-model="modelValue.descripcion" readonly id="item" placeholder="Producto">
                                Producto
                            </input-field>
                            <button @click="$modal.show('items')" class="btn-info" type="button"><i class="fa fa-search"></i></button>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                        <input-field v-model="modelValue.cantidad" vMoney :format="decimal" id="cantidad" placeholder="##.##">
                            Cantidad
                        </input-field>
                    </div>
                </div>
            </div>
            <div class="modal-buttons">
                <button @click="$emit('cancelar')" class="btn-danger btn--text" type="button"><i class="fa fa-ban"></i><span>Cancelar</span></button>
                <button @click="aceptar" class="btn-success" type="button"><i class="fa fa-check"></i><span>Aceptar</span></button>
            </div>
        </div>
        <modal height="auto" width="70%" scrollable name="items">
            <lista-item tipoProducto="P" :tipo="tipo" :searchButton="false" @selected="seleccionarItem" :filterStatus="false" :createButton="true"></lista-item>
        </modal>
    </div>
</template>

<script>
export default {
    props : {
        value : {
            type : Object,
            required : false,
            default : function () {
                return {
                    codigo : '',
                    descripcion : '',
                    cantidad : 1
                };
            }
        },
        tipo : {
            type : String,
            required : false,
            default : 'E'
        }
    },
    data : function () {
        return {
            decimal : decimal,
            modelValue : this.value
        };  
    },
    methods : {
        aceptar : function () {
            let cantidad = parseFloat(this.modelValue.cantidad);
            if (!isNaN(cantidad) && cantidad === 0) 
                swal('La cantidad debe ser mayor a 0.', 'Mensaje', 'warning');
            else if (this.modelValue.codigo === '' || this.modelValue.cantidad === '')
                swal('El producto y la cantidad son requeridos.', 'Mensaje', 'warning');
            else
                this.$emit('input', this.modelValue);
        },
        seleccionarItem : function (item) {
            this.modelValue.codigo = item.codigo;
            this.modelValue.descripcion = item.nombre;
            this.$modal.hide('items');
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/ItemGuiaRemision.vue